import { linearTiming } from "@remotion/transitions";
import { TransitionKind, TransitionSpeed } from "@repo/api/transition";
import { msToFrames } from "../../utils/timing.ts";
import {
  getDefaultPreviewClipDurationsInFrames,
  ImageTransitionBuilder,
  ImageTransitionBuilderProps,
} from "./ImageTransitionBuilder.ts";
import { focusPull, FocusPullProps } from "../remocn/focus-pull.tsx";

const transitionKind = TransitionKind.enum.FOCUS_PULL;

// NORMAL matches remocn's recommended 46 frames @ 30fps.
const FOCUS_PULL_DURATION_MS: Record<TransitionSpeed, number> = {
  SLOW: 2000,
  NORMAL: 1550,
  FAST: 1000,
};

// Peak defocus in px; remocn's default of 16 reads as heavy-handed.
export const FOCUS_PULL_BLUR = 10;
// Peak exposure boost; remocn's default of 1.3 looks overexposed on photos.
export const FOCUS_PULL_BRIGHTNESS = 1.1;

function getFocusPullDurationInFrames(props: ImageTransitionBuilderProps) {
  return msToFrames(
    FOCUS_PULL_DURATION_MS[props.imageTransition.speed ?? "NORMAL"],
    props.fps,
  );
}

export const ImageFocusPullTransitionBuilder: ImageTransitionBuilder<FocusPullProps> =
  {
    formConfig: {
      kind: transitionKind,
      buildDefaultValue: () => ({ kind: transitionKind, speed: "NORMAL" }),
      speed: ["SLOW", "NORMAL", "FAST"],
    },

    transition: {
      getDurationInFrames: getFocusPullDurationInFrames,
      buildPresentation: () =>
        focusPull({ blur: FOCUS_PULL_BLUR, brightness: FOCUS_PULL_BRIGHTNESS }),
      // The presentation eases internally, so the timing stays linear.
      buildTiming: (props) =>
        linearTiming({ durationInFrames: getFocusPullDurationInFrames(props) }),
    },

    getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
  };
